module.exports = __webpack_public_path__ + "static/media/1024982.5bfa59ca.png";